<template>
  <span>{{ hours }}hod. {{ minutes }}min.</span>
</template>

<script>
import DataTypeMixin from 'CORE/mixins/dataType'

export default {
    name: 'IntervalDetail',
    mixins: [
        DataTypeMixin,
    ],
    computed: {
        hours() {
            return _.get(this.value, 'value.value.hours', '0')
        },
        minutes() {
            return _.get(this.value, 'value.value.minutes', '0')
        }
    },
}
</script>

<style>

</style>
